import { IVector, IPoint, ISize, Vector, Rectangle, Point, Size } from "../../../../base/domain/drawing";
import { IPropertyEditable, IPropertyPresentable } from "../../../../base/domain/system/edit";
import { IFormatSpecification } from "../IFormatSpecification";
import { IVectorCoordinatableObject } from "../objects";
import { AbstractFormatObjectEditor } from "../AbstractFormatObjectEditor";
import { IVectorCoordinateEditable } from "../properties";

export abstract class AbstractVectorCoordinatableObjectEditor<TObject extends IVectorCoordinatableObject> extends AbstractFormatObjectEditor<TObject> implements IVectorCoordinateEditable {
  constructor(source: TObject | AbstractVectorCoordinatableObjectEditor<TObject>, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
    this._vector = this.createPropertyEditor(s => s.vector, (s, v) => s.vector = Vector.to(Vector.from(v).floor()));
    this._location = this.createPropertyPresenter(s => Point.to(Rectangle.from(Vector.from(s.vector)).topLeft));
    this._size = this.createPropertyPresenter(s => Size.to(Rectangle.from(Vector.from(s.vector)).size));
    this._from = this.createPropertyEditor(
      s => Point.from(s.vector.from),
      (s, v) => s.vector.from = Point.to(Point.from(v).floor()));
    this._to = this.createPropertyEditor(
      s => Point.from(s.vector.to),
      (s, v) => s.vector.to = Point.to(Point.from(v).floor()));
  }

  protected _vector: IPropertyEditable<IVector>;
  protected _location: IPropertyPresentable<IPoint>;
  protected _size: IPropertyPresentable<ISize>;
  protected _from: IPropertyEditable<IPoint>;
  protected _to: IPropertyEditable<IPoint>;

  vector(): IPropertyEditable<IVector> {
    return this._vector;
  }

  location(): IPropertyPresentable<IPoint> {
    return this._location;
  }

  size(): IPropertyPresentable<ISize> {
    return this._size;
  }

  from(): IPropertyEditable<IPoint> {
    return this._from;
  }

  to(): IPropertyEditable<IPoint> {
    return this._to;
  }

  getOverview(): string {
    const vector = this.vector().getValue();
    return this.getIdentifierOverview()
      + " (" + vector.from.x + "," + vector.from.y + ") -"
      + " (" + vector.to.x + "," + vector.to.y + ")";
  }
}
